import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from './../components/api'
// import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'
import { Link } from 'react-router-dom'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'


import StatusValidacaoSecao from '../components/StatusValidacaoSecao'



const EstruturaAdm = (props) => {


    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id



    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()


    const [questao10, setQuestao10] = useState()
    const [questao11, setQuestao11] = useState()
    const [questao12, setQuestao12] = useState()
    const [questao13, setQuestao13] = useState()
    const [questao14, setQuestao14] = useState()
    
    
    const [totalPendencias, setTotalPendencias] = useState(0)


    // var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    //var [adesao_institucional_id, setAdesaoInstitucionalId] = useState(sessionStorage.getItem('adesao_institucional_id'))
    var [compras_id, setCompras_id] = useState()

    var [comprasCentralizada, setComprasCentralizada] = useState()
    var [comprasCompartilhada, setComprasCompartilhada] = useState()
    var [tdSustent, setTdSustent] = useState()
    var [tdCIPA, setTdCIPA] = useState()
    var [tdInfecHosp, setTdInfecHosp] = useState()
    var [tdGerResiduos, setTdGerResiduos] = useState()
    var [tdBiosseg, setTdBiosseg] = useState()
    var [tdGerRiscoPac, setTdGerRiscoPac] = useState()
    var [comiteCompras, setComiteCompras] = useState()
    var [medicaoDesemp, setMedicaoDesemp] = useState()
    var [medicaoDesempDescri, setMedicaoDesempDescri] = useState('')

    var [tdInfecHospOutro, setTdInfecHospOutro] = useState('')
    var [tdGerResiduosOutro, setTdGerResiduosOutro] = useState('')
    var [tdBiossegOutro, setTdBiossegOutro] = useState('')
    var [tdGerRiscoPacOutro, setTdGerRiscoPacOutro] = useState('')
    var [tdSustentOutro, setTdSustentOutro] = useState('')
    var [tdCIPAOutro, setTdCIPAOutro] = useState('')
    var [tdOutro, setTdOutro] = useState('')
    var [tdOutroOpc, setTdOutroOpc] = useState('')
    

    function salvaEstruturaAdm() {

        var dataPost = {

            comprasCentralizada: comprasCentralizada,
            comprasCompartilhada: comprasCompartilhada,
            tdSustent: tdSustent,
            tdCIPA: tdCIPA,
            tdInfecHosp: tdInfecHosp,
            tdGerResiduos: tdGerResiduos,
            tdBiosseg: tdBiosseg,
            tdGerRiscoPac: tdGerRiscoPac,
            comiteCompras: comiteCompras,
            medicaoDesemp: medicaoDesemp,
            medicaoDesempDescri: medicaoDesempDescri,

        }

        //console.log(dataPost)

        //console.log(compras_id, '!?')

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (compras_id) {


                        api.put(`comprasEstruturaAdm/${compras_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {


                        api.post(`comprasEstruturaAdm/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                            console.log(result.data)

                            setCompras_id(result.data[0].compras_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    }

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }

    async function carregaComprasEstruturaAdm() {

        setCompras_id()
        setComprasCentralizada()
        setComprasCompartilhada()
        setTdSustent()
        setTdCIPA()
        setTdInfecHosp()
        setTdGerResiduos()
        setTdBiosseg()
        setTdGerRiscoPac()
        setComiteCompras()
        setMedicaoDesemp()
        setMedicaoDesempDescri()
        setTdOutroOpc()


        if (ano && adesao_institucional_id) {


            await api.get(`comprasEstruturaAdm/${adesao_institucional_id}/${ano}`).then((result) => {


                //console.log(result.data)

                if (result.data[0]) {

                    var data = result.data[0]

                    setCompras_id(data.compras_id)
                    setComprasCentralizada(data.comprasCentralizada)
                    setComprasCompartilhada(data.comprasCompartilhada)
                    setTdSustent(data.tdSustent)
                    setTdCIPA(data.tdCIPA)
                    setTdInfecHosp(data.tdInfecHosp)
                    setTdGerResiduos(data.tdGerResiduos)
                    setTdBiosseg(data.tdBiosseg)
                    setTdGerRiscoPac(data.tdGerRiscoPac)
                    setComiteCompras(data.comiteCompras)
                    setMedicaoDesemp(data.medicaoDesemp)
                    setMedicaoDesempDescri(data.medicaoDesempDescri)

                    setTdInfecHospOutro(data.tdInfecHospOutro)
                    setTdGerResiduosOutro(data.tdGerResiduosOutro)
                    setTdBiossegOutro(data.tdBiossegOutro)
                    setTdGerRiscoPacOutro(data.tdGerRiscoPacOutro)
                    setTdSustentOutro(data.tdSustentOutro)
                    setTdCIPAOutro(data.tdCIPAOutro)
                    setTdOutro(data.tdOutro)
                    setTdOutroOpc(data.tdOutroOpc)
                }


            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    useEffect(() => {
        

        carregaComprasEstruturaAdm()


        setQuestao10()
        setQuestao11()
        setQuestao12()
        setQuestao13()
        setQuestao14()
        
        
        


    }, [ano, adesao_institucional_id])




    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao10()
        setQuestao11()
        setQuestao12()
        setQuestao13()
        setQuestao14()
        
        
        

        if (compras_id) {

            var dataPost = {

                formulario_id: compras_id,
                desafio: 'Compras',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case '10. Sua organização realiza compras de forma centralizada, ou seja, diferentes unidades de uma rede utilizam produtos ou serviços adquiridos em um mesmo contrato?':

                                totalErros = totalErros + 1
                                setQuestao10('red')
    
                            break

                            case '11. Sua organização realiza compras compartilhadas, ou seja, diferentes instituições ou redes independentes adquirem produtos ou serviços mediante negociação conjunta?':

                                totalErros = totalErros + 1
                                setQuestao11('red')

                            break

                            case '12. Com que frequência as áreas abaixo são consultadas na tomada de decisões relativas a compras e contratações em sua organização:':

                                totalErros = totalErros + 1
                                setQuestao12('red')

                            break

                            case '13. A sua organização possui um Comitê / Comissão para acompanhar as decisões em Compras Sustentáveis?':

                                totalErros = totalErros + 1 
                                setQuestao13('red')

                            break

                            case '14. Sua organização utiliza indicadores para medição de desempenho em Compras Sustentáveis?':

                                totalErros = totalErros + 1
                                setQuestao14('red')

                            break



                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    useEffect(() => {

        verificaValidacoes()

    }, [compras_id, verificaDesafio])



    return (

        <div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao10 }} onClick={() => {setEnunciado('10. Sua organização realiza compras de forma centralizada, ou seja, diferentes unidades de uma rede utilizam produtos ou serviços adquiridos em um mesmo contrato?');setSecaoEnunciado('Seção II');window.$('#modalValidacao').modal('show')}}>
                            10. Sua organização realiza compras de forma centralizada, ou seja, diferentes unidades de uma rede utilizam produtos ou serviços adquiridos em um mesmo contrato?
                            </Link>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comprasCentralizada" onChange={() => setComprasCentralizada('R')} checked={ comprasCentralizada == 'R' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>

                                Minha unidade é administrada por uma rede que utiliza uma central para a maior parte das aquisições e contratações
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comprasCentralizada" onChange={() => setComprasCentralizada('A')} checked={ comprasCentralizada == 'A' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Minha unidade é administrada por uma rede que utiliza uma central apenas para algumas categorias de aquisições e contratações
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comprasCentralizada" onChange={() => setComprasCentralizada('I')} checked={ comprasCentralizada == 'I' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Minha unidade é administrada por uma rede, mas não utiliza uma central de compras e todas as aquisições e contratações são realizadas individualmente
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comprasCentralizada" onChange={() => setComprasCentralizada('N')} checked={ comprasCentralizada == 'N' ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                                Minha unidade não é administrada por uma rede.
                            </td>
                            
                        </tr>            
                        

                    </tbody>
                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao11 }} onClick={() => {setEnunciado('11. Sua organização realiza compras compartilhadas, ou seja, diferentes instituições ou redes independentes adquirem produtos ou serviços mediante negociação conjunta?');setSecaoEnunciado('Seção II');window.$('#modalValidacao').modal('show')}}>
                            11. Sua organização realiza compras compartilhadas, ou seja, diferentes instituições ou redes independentes adquirem produtos ou serviços mediante negociação conjunta?
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comprasCompartilhada" onChange={() => setComprasCompartilhada('S')} checked={ comprasCompartilhada == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, com frequência
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comprasCompartilhada" onChange={() => setComprasCompartilhada('E')} checked={ comprasCompartilhada == 'E' ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                            Sim, eventualmente
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comprasCompartilhada" onChange={() => setComprasCompartilhada('N')} checked={ comprasCompartilhada == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Não, nunca realizamos compras compartilhadas
                            </td>
                            
                        </tr>      
                       
                    </tbody>
                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="3">
                            <Link style={{ color: questao12 }} onClick={() => {setEnunciado('12. Com que frequência as áreas abaixo são consultadas na tomada de decisões relativas a compras e contratações em sua organização:');setSecaoEnunciado('Seção II');window.$('#modalValidacao').modal('show')}}>
                            12. Com que frequência as áreas abaixo são consultadas na tomada de decisões relativas a compras e contratações em sua organização:
                            </Link>
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Sustentabilidade / Meio Ambiente
                                </div>
                                
                            </td>
                            <td>
                                
                                <select id="tdSustent" value={tdSustent} onChange={event => setTdSustent(event.target.value)} disabled >
                                        <option value="">[Selecione]</option>
                                        <option value="M"  >Muito frequentemente</option>
                                        <option value="F"  >Frequentemente</option>
                                        <option value="E"  >Eventualmente</option>
                                        <option value="R"  >Raramente</option>
                                        <option value="N"  >Nunca</option>
                                        <option value="O"  >Outro</option>
                                    </select>
                                
                            </td> 
                            <td>

                                <input type="text" value={tdSustentOutro} onChange={event => setTdSustentOutro(event.target.value)} placeholder="Informe..." style={{ display: tdSustent == 'O' ? 'table-row' : 'none' }} disabled/>

                            </td>                              
                        </tr>      
                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    <span class="wrapper2">SESMT / CIPA
                                        <div class="tooltip">
                                            SESMT - Serviços Especializados em Engenharia de Segurança e em Medicina do Trabalho.<br/>
                                            CIPA - Comissão Interna de Prevenção de Acidentes.
                                        </div>
                                    </span>
                                </div>
                                
                            </td>
                            <td>
                                
                                <select id="tdCIPA" value={tdCIPA} onChange={event => setTdCIPA(event.target.value)} disabled>
                                        <option value="">[Selecione]</option>
                                        <option value="M"  >Muito frequentemente</option>
                                        <option value="F"  >Frequentemente</option>
                                        <option value="E"  >Eventualmente</option>
                                        <option value="R"  >Raramente</option>
                                        <option value="N"  >Nunca</option>
                                        <option value="O"  >Outro</option>
                                    </select>
                                
                            </td>  
                            <td>

                                <input type="text" disabled value={tdCIPAOutro} placeholder="Informe..." maxLength="255" onChange={event => setTdCIPAOutro(event.target.value)} style={{ display: tdCIPA == 'O' ? 'table-row' : 'none' }} />

                            </td>                             
                        </tr>     
                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                <span class="wrapper2">Comissão / Serviço de Controle de Infecção Hospitalar
                                    <div class="tooltip">
                                        Comissão / Serviço de Controle de Infecção Hospitalar atua na prevenção e controle de infecções hospitalares por meio da elaboração e orientação de medidas para redução da incidência e gravidade dessas enfermidades.
                                    </div>
                                </span>
                                
                                </div>
                                
                            </td>
                            <td>
                                
                                <select id="tdInfecHosp" value={tdInfecHosp} onChange={event => setTdInfecHosp(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="M"  >Muito frequentemente</option>
                                    <option value="F"  >Frequentemente</option>
                                    <option value="E"  >Eventualmente</option>
                                    <option value="R"  >Raramente</option>
                                    <option value="N"  >Nunca</option>
                                    <option value="O"  >Outro</option>
                                </select>
                            
                            </td>  
                            <td>

                                <input type="text" disabled placeholder="Informe..." value={tdInfecHospOutro} maxLength="255" onChange={event => setTdInfecHospOutro(event.target.value)} style={{ display: tdInfecHosp == 'O' ? 'table-row' : 'none' }} />

                            </td>                            
                        </tr>     
                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    <span class="wrapper2">Comissão de Gerenciamento de Resíduos
                                        <div class="tooltip">
                                            Grupo multidisciplinar que assessora a liderança na definição das ações que visem à implantação e manutenção do PGRSS-Programa de Gerenciamento de Resíduos de Serviço de Saúde.
                                        </div>
                                    </span>
                                </div>
                                
                            </td>
                            <td>
                                
                                <select id="tdGerResiduos" value={tdGerResiduos} onChange={event => setTdGerResiduos(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="M"  >Muito frequentemente</option>
                                    <option value="F"  >Frequentemente</option>
                                    <option value="E"  >Eventualmente</option>
                                    <option value="R"  >Raramente</option>
                                    <option value="N"  >Nunca</option>
                                    <option value="O"  >Outro</option>
                                </select>
                            
                            </td>   
                            <td>

                                <input type="text" disabled placeholder="Informe..." value={tdGerResiduosOutro}  maxLength="255" onChange={event => setTdGerResiduosOutro(event.target.value)}  style={{ display: tdGerResiduos == 'O' ? 'table-row' : 'none' }} />

                            </td>                          
                        </tr>  

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                <span class="wrapper2">Comissão de Biossegurança (ou similar)
						<div class="tooltip">
							A biossegurança compreende um conjunto de ações destinadas a prevenir, controlar, mitigar ou eliminar riscos inerentes às atividades que possam interferir ou comprometer a qualidade de vida, a saúde humana e o meio ambiente.<br/>
							O Comitê de Biossegurança define estratégias de atuação, avaliação e acompanhamento das ações ligadas à biossegurança.
						</div>
					</span>
                                </div>
                                
                            </td>
                            <td>
                                
                                <select id="tdBiosseg" value={tdBiosseg} onChange={event => setTdBiosseg(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="M"  >Muito frequentemente</option>
                                    <option value="F"  >Frequentemente</option>
                                    <option value="E"  >Eventualmente</option>
                                    <option value="R"  >Raramente</option>
                                    <option value="N"  >Nunca</option>
                                    <option value="O"  >Outro</option>
                                </select>
                            
                            </td>       
                            <td>

                                <input type="text" disabled placeholder="Informe..." value={tdBiossegOutro} maxLength="255" onChange={event => setTdBiossegOutro(event.target.value)} style={{ display: tdBiosseg == 'O' ? 'table-row' : 'none' }} />

                            </td>                       
                        </tr>  


                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                <span class="wrapper2">Comissão de Gerenciamento de Risco e/ou Segurança do Paciente
                                    <div class="tooltip">
                                        Grupo que contribui com o gerenciamento de riscos em saúde, por meio da definição e aplicação de políticas, procedimentos, condutas e recursos na avaliação de riscos e eventos adversos que afetam a segurança, a saúde humana, a integridade profissional, o meio ambiente e a imagem institucional.
                                    </div>
                                </span>
                                </div>
                                
                            </td>
                            <td>
                                
                                <select id="tdGerRiscoPac" value={tdGerRiscoPac} onChange={event => setTdGerRiscoPac(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="M"  >Muito frequentemente</option>
                                    <option value="F"  >Frequentemente</option>
                                    <option value="E"  >Eventualmente</option>
                                    <option value="R"  >Raramente</option>
                                    <option value="N"  >Nunca</option>
                                    <option value="O"  >Outro</option>
                                </select>
                            
                            </td>     
                            <td>

                                <input type="text" disabled placeholder="Informe..." value={tdGerRiscoPacOutro} maxLength="255" onChange={event => setTdGerRiscoPacOutro(event.target.value)} style={{ display: tdGerRiscoPac == 'O' ? 'table-row' : 'none' }} />

                            </td>                          
                        </tr>  

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Comissão da Padronização
                                </div>
                                
                            </td>
                            <td>

                                <select id="tdOutroOpc" value={tdOutroOpc} onChange={event => setTdOutroOpc(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="M"  >Muito frequentemente</option>
                                    <option value="F"  >Frequentemente</option>
                                    <option value="E"  >Eventualmente</option>
                                    <option value="R"  >Raramente</option>
                                    <option value="N"  >Nunca</option>
                                    <option value="O"  >Outro</option>
                                </select>
                                
                                   
                            
                            </td>     
                            <td>

                                <input id="tdOutro" value={tdOutro} onChange={event => setTdOutro(event.target.value)} disabled style={{display: 'none'}}/>
                                

                            </td>                          
                        </tr>  
                        
                       
                    </tbody>
                </Table>

            </div>


            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao13 }} onClick={() => {setEnunciado('13. A sua organização possui um Comitê / Comissão para acompanhar as decisões em Compras Sustentáveis?');window.$('#modalValidacao').modal('show')}}>
                            13. A sua organização possui um Comitê / Comissão para acompanhar as decisões em Compras Sustentáveis?
                            </Link>
                            
			
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comiteCompras" onClick={() => setComiteCompras('S')} checked={ comiteCompras == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, possui um Comitê/Comissão de Compras Sustentáveis que acompanha regularmente e de forma abrangente as decisões de compras e contratações
                            </td>
                            
                        </tr>    
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comiteCompras" onClick={() => setComiteCompras('C')} checked={ comiteCompras == 'C' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, possui um Comitê/Comissão de Compras Sustentáveis que opina sobre as decisões de compras e contratações sempre que solicitado
                            </td>
                            
                        </tr> 
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comiteCompras" onClick={() => setComiteCompras('N')} checked={ comiteCompras == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Não possui um Comitê/Comissão específico para Compras Sustentáveis, mas as decisões de compras são avaliadas regularmente pelas áreas responsáveis por sustentabilidade, meio ambiente e/ou segurança
                            </td>
                            
                        </tr> 
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comiteCompras" onClick={() => setComiteCompras('F')} checked={ comiteCompras == 'F' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Não possui um fluxo de trabalho definido para para apoiar a sustentabilidade nas compras da organização
			
                            </td>
                            
                        </tr> 
                        

                    </tbody>

                </Table>

            </div>


            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao13 }} onClick={() => {setEnunciado('14. Sua organização utiliza indicadores para medição de desempenho em Compras Sustentáveis?');setSecaoEnunciado('Seção II');window.$('#modalValidacao').modal('show')}}>
                            14. Sua organização utiliza indicadores para medição de desempenho em Compras Sustentáveis?
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                
                                <center>
                                <input type="radio" name="medicaoDesemp" onClick={() => setMedicaoDesemp(true)} checked={ medicaoDesemp == true ? 1 : medicaoDesemp == false ? 0 : null} disabled />
                                </center>
                            </td>
                            <td>
                                Sim
                                <div style={{ display: medicaoDesemp ? 'table-row' : 'none' }} >
                                 Por favor, descreva resumidamente o(s) indicador(es) utilizado(s)<br/>
                                <input type="text" size="80" maxlength="255" id="medicaoDesempDescri" placeholder="Aqui..." value={medicaoDesempDescri} onChange={event => setMedicaoDesempDescri(event.target.value)} disabled />
                                </div>
                            </td>
                            
                        </tr>    
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                
                                <input type="radio" name="medicaoDesemp" onClick={() => setMedicaoDesemp(false)} checked={ medicaoDesemp == false ? 1 : medicaoDesemp == true ? 0 : null}  disabled />
                                </center>
                            </td>
                            <td>
                                Não
                            </td>
                            
                        </tr>    
                        
                        

                    </tbody>

                </Table>

            </div>

            <StatusValidacaoSecao desafio="Compras" secaoCampo="secaoII" totalPendencias={totalPendencias} nomeDesafio="Desafio Compras" formulario_id={compras_id} secao="Seçao II - Estrutura Administrativa" ano={ano} />

        </div>
    )

}

export default EstruturaAdm